import { all } from 'redux-saga/effects'
import resourcesSaga from './resources.sagas'

export default function* () {
	yield all([resourcesSaga()])
}
